module.exports = __webpack_public_path__ + "img/AI_Chatbot.1a2e9940.jpg";